/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'

import layout from '~/components/layout'
import layoutAside from '~/components/layout/aside'
import layoutContainer from '~/components/layout/container'
import layoutContainerHeader from '~/components/layout/container/header'
import layoutContainerMain from '~/components/layout/container/main'

import mainContent from '~/components/layout/container/main/content'
import mainFooter from '~/components/layout/container/main/footer'

import borderTitle from '~/components/border-title.vue'
import tableBox from '~/components/tableBox'

// 布局组件
Vue.component('layout', layout)
Vue.component('layoutAside', layoutAside)
Vue.component('layoutContainer', layoutContainer)
Vue.component('layoutContainerHeader', layoutContainerHeader)
Vue.component('layoutContainerMain', layoutContainerMain)
Vue.component('mainContent', mainContent)
Vue.component('mainFooter', mainFooter)

// 全局小组件
Vue.component('borderTitle', borderTitle)
Vue.component('tableBox', tableBox)



// WEBPACK FOOTER //
// ./src/utils/components.js